<template>
    <div class="container">
        <div class="section">
            <img class="se-img" src="https://s20.lgstatic.com/growth/activity/20220708/1657247551962.png">
        </div>
        <div class="ceiling-view" v-if="ceilingType" :class="{'ceiling-fixed':ceilingType}">
            <div class="ceiling-tab">
                <div class="tab-item"
                    v-for="(item, index) in tabList" :key="index"
                    :class="{'active-tab': activeTab === index}"
                    @click="changeTab(item,index)"
                >
                    <span>{{item.stage}}</span>
                    <div v-if="activeTab === index" class="bor" />
                </div>
            </div>
        </div>
        <div class="section">
            <img class="se-img" src="https://s20.lgstatic.com/growth/activity/20220708/1657248007655.png">
        </div>
        <div class="section">
            <img class="se-img" src="https://s20.lgstatic.com/growth/activity/20220708/1657248029134.png">
            <div class="section-line" id="section_0"></div>
        </div>
        <div class="section-main">
            <div class="section">
                <img class="se-img" src="https://s21.lgstatic.com/growth/activity/20220708/1657248375740.png" alt="">
            </div>
            <div class="course-section flex">
                <div class="section-left flex flex-column a-center">
                    <button
                        v-for="(item, index) in stageList"
                        :key="index"
                        :class="{'s-l-i': true, 's-l-i-a': SI === index}"
                        @click="SI = index"
                    >
                        {{ item.stage }}
                    </button>
                </div>
                <div class="section-right flex-1">
                    <div class="n-top flex">
                        <span class="n-t-d flex-1">{{ currentStage.title }}</span>
                        <div class="detail-course" @click="JumpFn('领取完整课程安排')"><span>详细内容></span></div>
                    </div>
                    <template v-if="SI != 1">
                        <div class="s-container" v-for="(its, indexs) in currentStage.list" :key="indexs">
                            <div class="s-c-title">
                                {{its.l_title}}
                            </div>
                            <div
                                v-for="(it, i) in its.l_ls" :key="i"
                                :class="{'s-n-item':indexs === 1,'s-n-items': indexs === 0||indexs === 2}"
                            >
                                {{it}}
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <div class="s-container" v-for="(its, indexs) in currentStage.list" :key="indexs">
                            <div class="s-c-title">
                                {{its.l_title}}
                            </div>
                            <template v-if="indexs === 0">
                                <div class="its-2">
                                    <div class="sw-n-l">
                                        网页轮播图特效案例 <br>
                                        元素入场动画特效案例 <br>
                                        『豆瓣电影榜单』网页应用项目 <br>
                                        『Todos 待办清单』网页应用项目 <br>
                                    </div>
                                    <div class="sw-n-r">

                                        『贪食蛇』小游戏项目 <br>
                                        『网络留言板』网页应用项目 <br>
                                        『网页记事本』网页应用项目 <br>
                                        『购物车』局部功能案例 <br>
                                    </div>
                                </div>
                            </template>
                            <template v-else>
                                <div
                                    v-for="(it, i) in its.l_ls" :key="i"
                                    :class="{'s-n-item':indexs === 1,'s-n-items':indexs === 2}"
                                >
                                    {{it}}
                                </div>
                            </template>
                        </div>
                    </template>

                    <div class="tips-tab">
                        * 具体课程内容以实际课程安排和进度为准
                    </div>
                </div>
                <img class="course-btn" @click="JumpFn('领取完整课程安排')" src="https://s20.lgstatic.com/growth/activity/20220708/1657264683692.png" alt="">
            </div>
        </div>
        <div class="section" id="section_1">
            <img class="se-img" src="https://s21.lgstatic.com/growth/activity/20220708/1657248848160.png">
        </div>
        <div class="section-pro">
            <div class="swiper-container swiper-container-pro">
                <div class="swiper-wrapper">
                    <div v-for="(pro, i) in projectData" :key="i" class="swiper-slide pro-content">
                        <div class="left">
                            <div class="title">{{ pro.title }}</div>
                            <div v-for="(item, j) in pro.data" :key="j" class="pro-details">
                                <div class="detail-title">{{ item.title }}</div>
                                <div v-if="item.desc" class="detail-txt">{{ item.desc }}</div>
                                <div v-for="(dataItem, k) in item.data" :key="k" class="detail-item">
                                    <div  v-if="dataItem.title" class="detail-item-title">{{ dataItem.title }}</div>
                                    <div v-for="(txt, l) in dataItem.txt" :key="l" class="detail-item-txt">{{ txt }}</div>
                                </div>
                            </div>
                        </div>
                        <img class="right-img" :src="pro.proImg" alt="">
                        <div class="tips-tab">
                            * 具体课程内容以实际课程安排和进度为准
                        </div>
                    </div>
                </div>
                <div class="swiper-pagination"></div>
            </div>
            <img class="section-btn" @click="JumpFn('获取更多项目资料')" src="https://s21.lgstatic.com/growth/activity/20220708/1657264451441.png" alt="">
        </div>
        <div class="section" id="section_2">
            <img class="se-img" src="https://s20.lgstatic.com/growth/activity/20221118/1668752732227.jpg">
        </div>
        <!-- <div class="section" id="section_3">
            <img class="se-img" src="https://s21.lgstatic.com/growth/activity/20220708/1657249188442.png">
        </div> -->
        <!-- <div class="section-sw" id="section_4">
            <img class="img" src="https://s20.lgstatic.com/growth/activity/20220708/1657260609755.png" alt="">
            <div class="swiper-container sw1-wrap">
                <div class="swiper-wrapper">
                    <div v-for="item in swiperList" :key="item" class="swiper-slide">
                        <img :src="item" >
                    </div>
                </div>
                <div class="swiper-pagination sw1-pagination" />
                <div class="swiper-button-next"></div>
                <div class="swiper-button-prev"></div>
            </div>
        </div>
        <div class="section">
            <img class="se-img" src="https://s20.lgstatic.com/growth/activity/20220708/1657249220513.png">
        </div> -->
        <div class="section">
            <img class="se-img" src="https://s21.lgstatic.com/growth/activity/20221118/1668752763468.jpg">
        </div>
        <!-- <img src="https://s20.lgstatic.com/growth/activity/20210928/1632809765330.png" alt="" class="privity-offter">

        <div class="section" v-for="(item, index) in PCimglist" :key="index">
            <img class="se-img" v-if="item.type == 'img'" :src="item.url">
            <button class="se-btn-1" v-else @click="JumpFn()" :style="{'background-image':'url('+item.url+')'}"></button>
            <div class="activityBox" v-if="activity.isShow && index == 0">
                <img class="activityImg" :src="activity.PCactiveImg">
            </div>
        </div>
        <button class="se-btn-1" @click="JumpFn()" :style="{'background-image':'url('+btnImgList[0]+')'}"></button>
        <div class="section-touch">
            <div class="section">
                <img class="se-img" src="https://s20.lgstatic.com/growth/activity/20210928/1632802290227.png" alt="">
            </div>
            <div class="center">
                <div
                    class="touch-img" :class="[`img-${index}`]"
                    v-for="(item, index) in touchImglist" :key="index"
                    :style="{'background-image':'url('+item.url+')'}"
                >
                </div>
            </div>
        </div>

        <div class="section-swmain">
             <div class="section">
                <img class="se-img" src="https://s20.lgstatic.com/growth/activity/20210928/1632824000970.png" alt="">
            </div>
            <div class="swiper-container current-wrap">
                <div class="swiper-wrapper">
                    <div class="swiper-slide current-slider" v-for="(item, index) in PCSwiperList1" :key="index">
                        <img :src="item">
                    </div>
                </div>
                <div class="swiper-pagination current-pagination" />
            </div>
        </div>
        <button class="se-btn-1 swiper-top" @click="JumpFn()" :style="{'background-image':'url('+btnImgList[1]+')'}"></button>

        <div class="section">
            <img class="se-img" src="https://s21.lgstatic.com/growth/activity/20210928/1632803280460.png">
        </div>
        <div class="section-swmain-1">
            <div class="section">
                <img class="se-img" src="https://s21.lgstatic.com/growth/activity/20210928/1632803454917.png">
            </div>
            <div class="swiper-container swiper-wrap">
                <div class="swiper-wrapper">
                    <div class="swiper-slide current-slider" v-for="(item, index) in PCSwiperList2" :key="index">
                        <img :src="item">
                    </div>
                </div>
                <div class="swiper-pagination swiper-pagination" />
            </div>
        </div>
        <div class="section">
            <img class="se-img" :src="PCimglist1[0]">
        </div>
        <div class="section">
            <img class="se-img" :src="PCimglist1[1]">
        </div>
        <div class="section mg-s">
            <img class="se-img" :src="PCimglist1[2]">
        </div>
        <div class="section-swmain-2">
            <div class="section">
                <img class="se-img" src="https://s21.lgstatic.com/growth/activity/20210928/1632804169698.png">
            </div>
            <div class="swiper-container box-wrap">
                <div class="swiper-wrapper">
                    <div class="swiper-slide current-slider" v-for="(item, index) in PCSwiperList3" :key="index">
                        <img :src="item">
                    </div>
                </div>
                <div class="swiper-pagination box-pagination" />
            </div>
        </div>
        <button class="se-btn-1 swiper-top" @click="JumpFn()" :style="{'background-image':'url('+btnImgList[2]+')'}"></button>
        <div class="section">
            <img class="se-img" :src="PCimglist1[3]">
        </div>
         <div class="section">
            <img class="se-img" :src="PCimglist1[4]">
        </div> -->
        <button class="footer" @click="JumpFn('名额有限立即抢占')">
          <div class="box box-fixed">
            <div class="box-inner" @click="JumpFn('名额有限立即抢占')">
              <div class="box10-content">
                <div class="box10-left">
                  <img src="https://s21.lgstatic.com/growth/activity/20220610/1654846808855.png" alt="">
                  咨询课程顾问 抢大额优惠券
                </div>
                <div class="box10-right" @click="JumpFn('名额有限立即抢占')">好课速享 马上抢占</div>
              </div>
            </div>
          </div>
        </button>
    </div>
</template>

<script>
import { handleJumpUrl } from '../../../uitl/getParam.js';
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.css';
import activity from '../../../common/activity';
import List from './b-1'
import mixin from '../../../common/js/mixins/repurchase'

    export default {
        mixins: [mixin],
        data() {
            return {
                activity,
                List:List,
                SI: 0,
                tabList:[],
                activeTab: 0,
                touchImglist:[
                    {
                        url:"https://s21.lgstatic.com/growth/activity/20210312/1615517156981.png",
                        activeUrl:""
                    },{
                        url:"https://s21.lgstatic.com/growth/activity/20210312/1615517223420.png",
                        activeUrl:""
                    },{
                        url:"https://s21.lgstatic.com/growth/activity/20210312/1615517237543.png",
                        activeUrl:""
                    },{
                        url:"https://s21.lgstatic.com/growth/activity/20210312/1615517247464.png",
                        activeUrl:""
                    },{
                        url:"https://s21.lgstatic.com/growth/activity/20210312/1615517257708.png",
                        activeUrl:""
                    },{
                        url:"https://s21.lgstatic.com/growth/activity/20210312/1615517268702.png",
                        activeUrl:""
                    },{
                        url:"https://s21.lgstatic.com/growth/activity/20210312/1615517281233.png",
                        activeUrl:""
                    }
                ],
                PCimglist: [
                    {url:"https://s21.lgstatic.com/growth/activity/20220316/1647399215898.png",type:"img"},
                    {url:"https://s21.lgstatic.com/growth/activity/20220120/1642666173811.jpg",type:"img"},
                    {url:"https://s21.lgstatic.com/growth/activity/20210929/1632882115476.png",type:"img"},
                    {url:"https://s20.lgstatic.com/growth/activity/20210928/1632797972553.png",type:"btn"},
                    {url:"https://s20.lgstatic.com/growth/activity/20210928/1632798632759.png",type:"img"},
                    {url:"https://s20.lgstatic.com/growth/activity/20210929/1632887525669.png",type:"img"},

                ],
                PCSwiperList1:[
                    "https://s21.lgstatic.com/growth/activity/20210311/1615447681962.png",
                    "https://s21.lgstatic.com/growth/activity/20210311/1615447700768.png",
                    "https://s21.lgstatic.com/growth/activity/20210311/1615447722354.png"
                ],
                PCSwiperList2:[
                    // "https://s21.lgstatic.com/growth/activity/20210311/1615448886120.png",
                    "https://s21.lgstatic.com/growth/activity/20210312/1615536098887.png",
                    "https://s21.lgstatic.com/growth/activity/20210311/1615448906593.png"
                ],
                PCSwiperList3:[
                    "https://s21.lgstatic.com/growth/activity/20210311/1615450265507.png",
                    "https://s21.lgstatic.com/growth/activity/20210311/1615450295716.png",
                    "https://s21.lgstatic.com/growth/activity/20210311/1615450375686.png",
                    "https://s21.lgstatic.com/growth/activity/20210311/1615450393398.png",
                    "https://s21.lgstatic.com/growth/activity/20210311/1615450410221.png",
                    "https://s21.lgstatic.com/growth/activity/20210311/1615452839568.png"
                ],
                btnImgList:[
                    "https://s21.lgstatic.com/growth/activity/20210928/1632799392848.png",
                    "https://s21.lgstatic.com/growth/activity/20210928/1632803012015.png",
                    "https://s20.lgstatic.com/growth/activity/20210928/1632804020122.png"
                ],
                PCimglist1: [
                    // "https://s20.lgstatic.com/growth/activity/20210928/1632803620771.png",
                    "https://s21.lgstatic.com/growth/activity/20210928/1632803680973.png",
                    "https://s21.lgstatic.com/growth/activity/20210928/1632803843730.png",
                    "https://s20.lgstatic.com/growth/activity/20210928/1632804374805.png",
                    "https://s21.lgstatic.com/growth/activity/20220316/1647399281725.png"
                ],
                PCfooterImg:"https://s21.lgstatic.com/growth/activity/20220426/1650954950625.png",
                PCfooterImgB:"https://s21.lgstatic.com/growth/activity/20210826/1629981259793.png",
                stageList:[],
                courseId: 38,
                swiperList: [
                    "https://s20.lgstatic.com/growth/activity/20220708/1657261120433.png",
                    "https://s21.lgstatic.com/growth/activity/20220708/1657261129939.png",
                    "https://s21.lgstatic.com/growth/activity/20220708/1657261138459.png",
                    "https://s21.lgstatic.com/growth/activity/20220708/1657261149271.png"
                ],
                ceilingType:false,//吸顶tab
                projectData: [
                    {
                        title: "【教育】拉勾课堂",
                        proImg: "https://s20.lgstatic.com/growth/activity/20220708/1657263408587.png",
                        data: [
                            {
                                title: "项目介绍：",
                                desc: "在线教育平台，依托平台，在线选课、购课、在线学习",
                                data: [
                                    {
                                        title: '管理系统：',
                                        txt: [
                                            "• 登录功能、身份认证",
                                            "• 权限管理：功能、菜单、资源",
                                            "• 角色/用户管理：添加、分配、提交",
                                            "• 课程管理：新建、维护、上下架、活动",
                                            "• 内容管理：展示、更新、课程上传",
                                        ]
                                    },
                                    {
                                        title: '移动端：',
                                        txt: [
                                            "• 选课功能：广告、课程列表、布局、下拉刷新",
                                            "• 登录功能：校验、状态存储、状态检测",
                                            "• 用户功能：信息处理、菜单列表",
                                            "• 学习功能：接口抽离、封装、数据绑定",
                                            "• 课程详情：章节、视频、播放",
                                            "• 支付功能：结构处理、支付请求",
                                        ]
                                    }
                                ]
                            },
                            {
                                title: "核心内容模块：",
                                desc: "",
                                data: [
                                    {
                                        title: '管理端：',
                                        txt: [
                                            "Vue.js、Vue CLI、Vue Router、Vuex、Element UI、Axios、ESLint、Sass ",
                                        ]
                                    },
                                    {
                                        title: '移动端：',
                                        txt: [
                                            "Vue.js、Vue CLI、Vuex、Vue Router、Axios、Vant",
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        title: "【电商】拉勾心选",
                        proImg: "https://s20.lgstatic.com/growth/activity/20220708/1657263408587.png",
                        data: [
                            {
                                title: "项目介绍：",
                                desc: "电商平台，在线搜索、购买、支付",
                                data: [
                                    {
                                        title: '',
                                        txt: [
                                            "✓ 注册、登录功能",
                                            "✓ 分类功能、分类列表",
                                            "✓ 添加商品、商品列表、封面",
                                            "✓ 搜索布局、搜索功能、筛选",
                                            "✓ 购物车、添加、更改、删除",
                                            "✓ 支付创建、订单列表、修改订单"
                                        ]
                                    }
                                ]
                            },
                            {
                                title: "核心内容模块：",
                                desc: "",
                                data: [
                                    {
                                        title: '服务端：',
                                        txt: [
                                            "node.js、MongoDB、mongodb-compass",
                                        ]
                                    },
                                    {
                                        title: '客户端：',
                                        txt: [
                                            "react、react-router-dom、antd、redux、redux-saga、axios、redux-devtools-extension",
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                ],
                addressIdsMap: {
                    "课程体系": "m1tzi",
                    "实战项目": "n1tzj",
                    "就业服务": "p1tzk",
                    "用户评价": "q1tzm",
                    "领取完整课程安排": "r1tzn",
                    "获取更多项目资料": "s1tzp",
                    "名额有限立即抢占": "t1tzq"
                }
            }
        },
        computed: {
            currentStage() {
                return this.stageList[this.SI] || {};
            },
        },
        created () {
            setTimeout(()=>{
                // if(this.isAB) {
                //   this.eduPlatTrack('WebView', { page_id: '1qzq', 'page_from':'大课学习页'});
                // } else {
                //   this.eduPlatTrack('WebView', { page_id: '1qzq', 'test_version':'B版-实验版'});
                // }
                this.platTrack('pcpv', {
                    page_id: 'p1tyv',
                })
            },500)

            let dataList = this.List.data
            this.stageList = dataList.stageList
            this.tabList = dataList.tabList
            this.renderSwiper()
            window.addEventListener('scroll', this.scrollTopFn)
        },
        destroyed () {
            window.removeEventListener('scroll', this.scrollTopFn)
        },
        methods: {
            changeTab(item,index) {
                this.activeTab = index
                let arr = [
                    "#section_0",
                    "#section_1",
                    "#section_2",
                    // "#section_3",
                    // "#section_4",
                ]
                this.$el.querySelector(arr[index]).scrollIntoView(true);
                let scroll = document.documentElement.scrollTop || document.body.scrollTop;
                document.documentElement.scrollTop = scroll - 50
                document.body.scrollTop = scroll - 50
                // this.eduPlatTrack('WebButtonClick', {
                //     'page_id': '1pxi',
                //     'button_name': item.stage
                // });
                this.platTrackClickFn(item.stage);
            },
            scrollTopFn() {
                let scroll = document.documentElement.scrollTop || document.body.scrollTop;
                this.ceilingType = scroll > 520 ? true : false; //吸顶tab
                let arr = [
                    "section_0",
                    "section_1",
                    "section_2",
                    // "section_3",
                    // "section_4",
                ]
                arr.forEach((item,index) =>{
                    if(document.getElementById(item).getBoundingClientRect().top < 200) {
                        this.activeTab = index
                    }
                })
            },
            renderSwiper() {
                setTimeout(() => {
                    let modify = 0;
                    let translate = 0;
                    let scale = 0;
                    const swiper = new Swiper('.sw1-wrap', {
                        autoplay: 3000,
                        loop: true,
                        slidesPerView: 'auto',
                        loopedSlides: 4,
                        pagination: '.sw1-pagination',
                        paginationClickable: true,
                        watchSlidesProgress: true,
                        prevButton: '.swiper-button-prev',
                        nextButton: '.swiper-button-next',
                        centeredSlides: true,
                        onSetTransition: (swiper, transition) => {
                            for (let i = 0; i < swiper.slides.length; i++) {
                                let slide = swiper.slides.eq(i);
                                slide.transition(transition);
                            }
                        },
                    });

                    swiper.on('progress', () => {
                        for (let i = 0; i < swiper.slides.length; i++) {
                            let slide = swiper.slides.eq(i);
                            let slideProgress = swiper.slides[i].progress;
                            modify = 1;
                            if (Math.abs(slideProgress) > 1) {
                                modify = (Math.abs(slideProgress) - 1) * 0.3 + 1;
                            }
                            translate = slideProgress * modify * 500 + 'PX';
                            scale = 1 - Math.abs(slideProgress) / 5;
                            let zIndex = 999 - Math.abs(Math.round(10 * slideProgress));
                            slide.transform('translateX(' + translate + ') scale(' + scale + ')');
                            slide.css('zIndex', zIndex);
                        }
                    });
                }, 500);
                let option1 = {
                    loop: true,
                    speed: 800,
                    autoplayDisableOnInteraction: false,
                    autoplay: 3200,
                    pagination: '.swiper-pagination',
                    paginationClickable: '.swiper-pagination',
                    spaceBetween: 30
                }
                setTimeout(() => {
                    var swiper = new Swiper('.swiper-container-pro', option1);
                }, 1000)
            },
            JumpFn(str) {
            //   if(this.showNew) {
            //     this.eduPlatTrack('WebButtonClick', {
            //         'page_id': '1qzq',
            //         'courses_id': [this.courseId+''],
            //         'button_name': '试学申请',
            //     });
            //   } else {
            //     this.eduPlatTrack('WebButtonClick', {
            //         'page_id': '1qzq',
            //         'button_name': this.isBView === 'B' ? '免费领取vip月卡' : '抢先领取试学名额',
            //         'test_version':'B版-实验版',
            //     });
            //     }
                // handleJumpUrl(this.isBView === 'B' ? 'ae237c0e03cc478dbab8680b09220e18' : `40513c72e610470eb1deba11ca76ead4`);
                str && this.platTrackClickFn(str);
                setTimeout(() => {
                  window.location.href = 'https://t.lagou.com/DR25RsRss=A65';
                }, 200)
            },
            platTrackClickFn(name) {
                this.platTrack('pcclick', {
                    page_id: 'p1tyv',
                    address_id: this.addressIdsMap[name]
                })
            }
        },
    }
</script>

<style lang="less" scoped>
.container {
    width: 100%;
    padding-bottom: 116PX;
    background: #FFFBF3;
    position: relative;
    .privity-offter{
        position: absolute;
        top: 0;
        right: 15%;
        object-fit: contain;
        width: 104PX;
        height: 133PX;
    }
    button{
        cursor: pointer;
    }
}
.section-sw {
    position: relative;
    width: 100%;
    height: 753PX;
    background-image: linear-gradient(180deg, #FF8937 0%, #E94619 100%);
    .img {
        position: absolute;
        top: 32PX;
        left: 50%;
        width: 1108PX;
        transform: translateX(-50%);
    }
    /deep/ .sw1-wrap {
        position: absolute;
        top: 260PX;
        left: 50%;
        transform: translateX(-50%);
        width: 1200PX;
        height: 390PX;
        margin-top: 60PX;
        .swiper-slide {
            width: 782PX;
            height: 352PX;
            opacity: 0;
            img {
                display: block;
                width: 782PX;
                margin: 0 auto;
            }
            &.swiper-slide-active {
                opacity: 1;
            }
            &.swiper-slide-next, &.swiper-slide-prev {
                opacity: .5;
            }
        }
        .swiper-pagination {
            bottom: 0PX;
        }
        .swiper-pagination-bullet{
            width: 10PX;
            height: 10PX;
            background: linear-gradient(90deg, #fff 0%, #fff 100%);
            border-radius: 50%;
            opacity: .5;
            &-active{
                opacity: 1;
                border-radius: 10PX;
                width: 22PX;
                background: linear-gradient(90deg, #fff 0%, #fff 100%);
            }
        }
        .swiper-button-prev {
            background: url('https://s21.lgstatic.com/growth/activity/20210402/1617354468162.png') no-repeat center;
            background-size: 100% 100%;
            width: 58PX;
            height: 58PX;
            // top: 50%;
            // transform: translateY(-50%);
            // left: 0PX;
        }
        .swiper-button-next {
            background: url('https://s21.lgstatic.com/growth/activity/20210402/1617354439579.png') no-repeat center;
            background-size: 100% 100%;
            width: 58PX;
            height: 58PX;
            // // right: -80PX;
            // // top: 50%;
            // transform: translateY(-50%);
            // right: 0PX;
        }
    }
}
/deep/.section-pro {
    position: relative;
    width: 100%;
    .section-btn {
        width: 456PX;
        height: 83PX;
        display: block;
        margin: 20PX auto;
    }
    .tips-tab {
        position: absolute;
        font-size: 14PX;
        color: #666;
        bottom: 40PX;
        right: 60PX;
    }
    .pro-content {
        display: flex;
        width: 1114PX;
        height: 750PX;
        background-color: #fff;
        border-radius: 20PX;
        margin: 0 auto;
        padding: 40PX 20PX 40PX 20PX;
        box-sizing: border-box;
        align-items: center;
        .left {
            width: 520PX;
            height: 100%;
            .title {
                width: calc(100% - 50PX);
                height: 40PX;
                line-height: 40PX;
                background-image: linear-gradient(270deg, #FE9600 0%, #F66600 100%);
                border-radius: 4PX;
                padding-left: 12PX;
                box-sizing: border-box;
                font-family: PingFangSC-Medium;
                font-weight: 500;
                font-size: 20PX;
                color: #FFFFFF;
            }
            .pro-details {
                margin-top: 26PX;
                .detail-title {
                    height: 32PX;
                    line-height: 32PX;
                    font-family: PingFangSC-Medium;
                    font-weight: 500;
                    font-size: 23PX;
                    color: #666666;
                }
                .detail-txt {
                    font-family: SourceHanSansCN-Regular;
                    font-weight: 400;
                    font-size: 19PX;
                    color: #999999;
                    line-height: 25PX;
                    margin-bottom: 12PX;
                }
                .detail-item {
                    margin-bottom: 24PX;
                    .detail-item-title, .detail-item-txt {
                        font-family: SourceHanSansCN-Regular;
                        font-weight: 400;
                        font-size: 19PX;
                        color: #999999;
                        line-height: 25PX;
                    }
                }
            }
        }
        .right-img {
            width: 540PX;
            height: 346PX;
        }
    }
    .swiper-container {
        width: 1114PX;
        height: 780PX;
    }
    .swiper-container-horizontal > .swiper-pagination-bullets {
        bottom: 0;
    }
    .swiper-pagination-bullet{
        width: 10PX;
        height: 10PX;
        background-color: #FF9820;
        border-radius: 50%;
        opacity: .5;
        &-active{
            opacity: 1;
            border-radius: 10PX;
            width: 22PX;
            background-color: #FF9820;
        }
    }
}
.section {
    position: relative;
    width: 100%;
    font-size: 0;
    .section-line {
        position: absolute;
        top: 200PX;
        width: 100%;
        height: 1PX;
    }
    .se-img {
        width: 100%;
        display: block;
    }
    .activityBox {
        position: absolute;
        top: 0;
        left: 50%;
        transform: translate(-50%);
        width: 950PX;
        height: 150PX;
    }
    .activityImg {
        display: block;
        float: right;
        width: 104PX;
        height: 133PX;
    }
}
.se-btn-1 {
    width: 100%;
    height: 83PX;
    background-position: center;
    background-repeat: no-repeat;
    background-size: auto;
    border: none;
    display: block;
    background-color: #F8F8F8;
    cursor:pointer;
}
.swiper-top{
    padding-top: 30PX;
    box-sizing: content-box;
}
.section-touch {
    width: 100%;
    min-width: 1232PX;
    overflow: hidden;
    position: relative;
    background-color: #F8F8F8;
    background-size: 100% 100%;
    .center {
        width: 100%;
        margin: 0PX auto 60PX;
        position: relative;
        .touch-img {
            width: 809PX;
            height: 66PX;
            margin: 0 auto 6PX;
            background-position: center;
            background-repeat: no-repeat;
            background-size: 100% 100%;
        }
        .img-0:hover {
            background: url('https://s21.lgstatic.com/growth/activity/20210312/1615529158977.png') no-repeat center!important;
            width: 1232PX;
            height: 66PX;
            transition: width .3s;
            background-size: 100% 100%!important;
        }
        .img-1:hover {
            background: url('https://s21.lgstatic.com/growth/activity/20210312/1615529170327.png') no-repeat center!important;
            width: 1232PX;
            height: 66PX;
            transition: width .3s;
            background-size: 100% 100%!important;
        }
        .img-2:hover {
            background: url('https://s21.lgstatic.com/growth/activity/20210312/1615529180411.png') no-repeat center!important;
            width: 1232PX;
            height: 66PX;
            transition: width .3s;
            background-size: 100% 100%!important;
        }
        .img-3:hover {
            background: url('https://s21.lgstatic.com/growth/activity/20210312/1615529190919.png') no-repeat center!important;
            width: 1232PX;
            height: 66PX;
            transition: width .3s;
            background-size: 100% 100%!important;
        }
        .img-4:hover {
            background: url('https://s21.lgstatic.com/growth/activity/20210312/1615529200645.png') no-repeat center!important;
            width: 1232PX;
            height: 66PX;
            transition: width .3s;
            background-size: 100% 100%!important;
        }
        .img-5:hover {
            background: url('https://s21.lgstatic.com/growth/activity/20210312/1615529212378.png') no-repeat center!important;
            width: 1232PX;
            height: 66PX;
            transition: width .3s;
            background-size: 100% 100%!important;
        }
        .img-6:hover {
            background: url('https://s21.lgstatic.com/growth/activity/20210312/1615529221040.png') no-repeat center!important;
            width: 1232PX;
            height: 66PX;
            transition: width .3s;
            background-size: 100% 100%!important;
        }

    }
}

.section-main {
    width: 100%;
    min-width: 1200PX;
    // height: 639PX;
    margin-top: -1PX;
    background-color: #F8F8F8;
    background-size: auto 100%;
    overflow: hidden;
}
.section-swmain {
    width: 100%;
    min-width: 1200PX;
    background-color: #F8F8F8;
    background-size: auto 100%;
    overflow: hidden;
    position: relative;
    .title-img {
        display: block;
        margin: 80PX auto 40PX;
        width: 902PX;
        height: 26PX;
    }
}
/deep/ .current-wrap {
    width: 1114PX;
    height: 450PX;
    .swiper-slide {
        width: 1114PX;
        height: 422PX;
        img {
            width: 100%;
            height: 100%;
        }
    }
    .swiper-pagination {
        bottom: 0PX;
    }
    .swiper-pagination-bullet{

        width: 10PX;
        height: 10PX;
        background: rgba(240,114,52,.4);
        border-radius: 50%;
        opacity: 1;
        &-active{
            border-radius: 10PX;
            width: 22PX;
            background: #F07234;
        }
    }
}
.section-swmain-1 {
    width: 100%;
    min-width: 1264PX;
    height: 727PX;
    background-color: #F8F8F8;
    background-size: auto 100%;
    overflow: hidden;
    position: relative;
}
/deep/ .swiper-wrap {
    margin: 0PX auto 0;
    width: 1264PX;
    height: 620PX;
    .swiper-slide {
        width: 1264PX;
        height: 595PX;
        img {
            width: 100%;
            height: 100%;
        }
    }
    .swiper-pagination {
        bottom: 0PX;
    }
    .swiper-pagination-bullet{
        width: 10PX;
        height: 10PX;
        background: rgba(240,114,52,.4);
        border-radius: 50%;
        opacity: 1;
        &-active{
            border-radius: 10PX;
            width: 22PX;
            background: #F07234;
        }
    }
}
.section-swmain-2 {
    width: 100%;
    min-width: 1200PX;
    background: #F8F8F8;
    background-size: 100% 100%;
    overflow: hidden;
    position: relative;
}
/deep/ .box-wrap {
    margin: 0 auto;
    width: 1001PX;
    height: 505PX;
    .swiper-slide {
        width: 1001PX;
        height: 455PX;
        img {
            width: 100%;
            height: 100%;
        }
    }
    .swiper-pagination {
        bottom: 0PX;
    }
    .swiper-pagination-bullet{
        width: 10PX;
        height: 10PX;
        background: rgba(240,114,52,.4);
        border-radius: 50%;
        opacity: 1;
        &-active{
            border-radius: 10PX;
            width: 22PX;
            background: #F07234;
        }
    }
}


.mg-s {
    margin-top: -5PX;
}
.footer {
    position: fixed;
    bottom: 0;
    z-index: 999;
    width: 100%;
    cursor: pointer;
    // height: 117PX;
    background-position: center;
    background-repeat: no-repeat;
    background-size: auto;
    border: none;
    font-size: 0;
    .iconBox {
        position: absolute;
        top: -30PX;
        left: 50%;
        transform: translate(-50%);
        z-index: 9999;
        width: 1060PX;
        .icon {
            float: right;
            width: 134PX;
        }
    }
    img {
      width: 100%;
    }
    .text-loop {
      position: absolute;
      width: 215PX;
      height: 37PX;
      right: 31.5%;
      top: 50%;
      transform: translateY(-50%);
      border: none;
      border-image-width: 0;
    }
}
.course-section {
    position: relative;
    width: 1200PX;
    background: #FFFFFF;
    border-radius: 10PX;
    // height: 500PX;
    margin: 0 auto 60PX;
    box-sizing: border-box;
    .course-btn {
        position: absolute;
        bottom: -42PX;
        left: 50%;
        width: 456PX;
        height: 83PX;
        transform: translateX(-50%);
    }
}
.section-left {
    width: 140PX;
    background: #F07234;
    border-radius: 10PX;
    padding-top: 24PX;
    box-sizing: border-box;
}
.s-l-i {
    width: 122PX;
    height: 38PX;
    border-radius: 19PX;
    color: white;
    background: #F07234;
    border: none;
    margin: 8PX 0;
}
.s-l-i-a {
    background: #FFFFFF;
    color: #F07234;
}
.section-right {
    padding: 17PX 40PX 60PX;
    position: relative;
    .tips-tab {
        position: absolute;
        font-size: 14PX;
        color: #666;
        bottom: 40PX;
        right: 60PX;
    }
}
.n-top {
    padding: 8PX 0 12PX;
    border-bottom: 1PX solid #B7B7B7;
    font-size: 22PX;
    .n-t-d {
        color: #333333;
        font-weight: 600;
        padding-right: 48PX;
        min-width: 210PX;
    }
    .detail-course{
        font-weight: 600;
        color: #F07234;
        font-size: 22PX;
        cursor: pointer;
    }
}
.s-container {
    font-size: 18PX;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #666666;
}
.s-c-title {
    font-size: 20PX;
    font-weight: 500;
    color: #333333;
    position: relative;
    padding-left: 14PX;
    padding-bottom: 10PX;
    margin-top: 20PX;
    &:first-of-type {
        margin-top: 13PX;
    }
    &::before {
        position: absolute;
        content: '';
        width: 4PX;
        height: 20PX;
        margin-top: 4PX;
        left: 0;
        background: #F07234;
    }
}
.s-n-item {
    padding-left: 20PX;
    position: relative;
    &::before {
        width: 2PX;
        height: 2PX;
        border-radius: 50%;
        background: #666666;
        content: '';
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: 5PX;
    }
}
.s-n-items {
    padding-left: 20PX;
    position: relative;
}
.its-2 {
    width: 100%;
    display: flex;
}
.sw-n-l {
    padding-left: 20PX;
    flex: 1;
}
.sw-n-r {
    flex: 1;
}
.ceiling-view {
    width: 100%;
    height: 66PX;
    margin: 0PX auto 40PX;
    background-color: #fff;
    .ceiling-tab {
        width: 1100PX;
        margin: 0 auto;
        height: 66PX;
        background-color: #fff;
        border-radius: 2PX;
        box-shadow: 0PX 6PX 8PX 0PX rgba(214, 209, 250, 0.08);
        display: flex;
        align-items: center;
        cursor: pointer;
        // transform: scale(.7);
        .tab-item {
            position: relative;
            flex: 1;
            text-align: center;
            font-size: 20PX;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #32355C;
            height: 100%;
            line-height: 66PX;
            box-sizing: border-box;
            .bor {
                position: absolute;
                bottom: 0;
                left: 50%;
                transform: translate(-50%);
                width: 168PX;
                height: 3PX;
                border-radius: 1PX;
                background: linear-gradient(309deg, #FF5A37 0%, #991010 100%);
            }
        }
        .active-tab {
            box-sizing: border-box;
            padding-left: 40PX;
            &::before{
                content: '';
                width: 24PX;
                height: 24PX;
                background: url('https://s20.lgstatic.com/growth/activity/20210923/1632364298791.png') no-repeat center;
                background-size: 100% 100%;
                position: absolute;
                left: 62PX;
                top:50%;
                transform: translateY(-50%);
                transition-duration: 0.3s;
            }
        }

    }
    @media screen and (max-width:1900px){
        .ceiling-tab {
            width: 940PX;
            .tab-item {
                .bor {
                    width: 148PX;
                }
            }
            .active-tab {
                padding-left: 40PX;
                &::before{
                    left: 44PX;
                }
            }
        }
    }
    @media screen and (max-width:1500px){
        .ceiling-tab {
            width: 790PX;
            .tab-item {
                .bor {
                    width: 140PX;
                }
            }
            .active-tab {
                padding-left: 30PX;
                &::before{
                    left: 26PX;
                }
            }
        }
    }

}
.ceiling-fixed {
    position: fixed;
    top: 0;
    left: 50%;
    transform: translate(-50%);
    z-index: 30;
}
.footer{
  .box {
    width: 100%;
    .box-inner {
      position: relative;
      width: 1200PX;
      height: 100%;
      margin: 0 auto;
      overflow: hidden;
    }
    &-fixed {
      position: fixed;
      bottom: 0;
      left: 0;
      height: 118PX;
      line-height: 118PX;
      background-color: #fff;
      z-index: 999;
    }
  }
  .box10-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .box10-left {
      display: flex;
      align-items: center;
      color: #ff8d5f;
      font-size: 26PX;
      & > img {
        width: 24PX;
        height: 24PX;
        margin-right: 12PX;
      }
    }
    .box10-right {
      width: 384PX;
      height: 68PX;
      line-height: 68PX;
      background: linear-gradient(90deg, #FF5487 0%, #FF854C 100%);
      border-radius: 39PX;
      font-size: 24PX;
      color: #fff;
      text-align: center;
    }
  }
}
</style>
